import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { Link } from 'react-router-dom';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { SIGN_OUT } from '../../common/Constants';
import JcpLogo from '../../assets/svg/jcp-logo-fullform.svg';
import BackArrow from '../../assets/svg/back-arrow.svg';

/* istanbul ignore next */
const B2bVoucherHeader = (props) => {
    // testing
    const AgentName = TokenProvider.get('DP_FIRST_NAME') || '';
    const AgentLastName = TokenProvider.get('DP_LAST_NAME') || '';
    const BackToText = TokenProvider.get('B2B_SOURCE_TEXT');
    const URLPath = TokenProvider.get('B2B_SOURCE_URL');

    const logoutToB2b = () => {
        TokenProvider.logout();
    };
    const backToPendingOrder = () => {
        LocalStorage.removeData('ACCOUNT_ID');
        Cookies.remove('ACCOUNT_ID');
        LocalStorage.removeData('orderId');
        Cookies.remove('b2b_orderId');
        window.location.href = URLPath;
    };
    return (
        <>
            <header
                className={dt([
                    'hidden',
                    'md:flex',
                    'justify-between',
                    'items-center',
                    'py-2',
                    'px-4',
                    'bg-black',
                    'text-white',
                    'w-full',
                ])}
            >
                <div className={dt(['flex', 'items-center', 'h-[40px]'])}>
                    <Icon
                        iconType="svg"
                        automationId="jcpLogo-icon"
                        className={`${dt(['pr-2'])}`}
                        width="80px"
                        height="80px"
                        viewBox="0 0 80 80"
                    >
                        <JcpLogo />
                    </Icon>
                    <h1 className={dt(['text-lg'])}>Voucher System</h1>
                </div>
                <div className={dt(['lex', 'items-center'])}>
                    <span className={dt(['mr-4'])}>
                        {AgentName !== '' ? `${AgentLastName}, ${AgentName}` : 'Admin'}
                    </span>
                    <a
                        href="#"
                        className={dt([
                            'text-[#29B4FF]', // todo check for color name
                            'hover:text-[#1a9cd8]', // todo check for color name
                            'transition duration-300',
                        ])}
                        onClick={logoutToB2b}
                    >
                        {SIGN_OUT}
                    </a>
                </div>
            </header>
            <nav className={dt(['hidden', 'md:block', 'bg-black', 'text-nav', 'w-full'])}>
                <ul className={dt(['items-center', 'px-4', 'flex', 'py-2', 'h-[50px]'])}>
                    <li>
                        <Link
                            to="#"
                            className={dt([
                                'transition',
                                'text-white',
                                'duration-300',
                                'hover:text-white',
                                'hover:underline',
                                'hover:decoration-primary',
                                'hover:decoration-4',
                                'underline-offset-4',
                                'inline-flex',
                                'items-center',
                            ])}
                            onClick={backToPendingOrder}
                        >
                            <Icon
                                iconType="svg"
                                automationId="backArrow-icon"
                                className={`${dt(['pr-2'])}`}
                                width="40px"
                                height="50px"
                                viewBox="0 0 40 40"
                            >
                                <BackArrow />
                            </Icon>
                            {BackToText}
                        </Link>
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default B2bVoucherHeader;
